"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateToRequest = void 0;
const guards_1 = require("../../guards");
const oas_1 = require("../../oas");
const accessors_1 = require("../../oas/accessors");
const accessors_2 = require("../accessors");
const guards_2 = require("../guards");
const params_1 = require("./params");
const pickBy = require("lodash.pickby");
const iterateOasParams = (0, accessors_1.createOasParamsIterator)(oas_1.OasVersion.OAS2);
const translateToRequest = function (path, operation) {
    const consumes = (0, accessors_2.getConsumes)(this.document, operation);
    const parameters = iterateOasParams.call(this, operation, path);
    const params = {
        headers: [],
        query: [],
        cookie: [],
        path: [],
    };
    let bodyParameter;
    const formDataParameters = [];
    for (const param of parameters) {
        if ((0, guards_2.isQueryParam)(param)) {
            params.query.push(params_1.translateToQueryParameter.call(this, param));
        }
        else if ((0, guards_2.isPathParam)(param)) {
            params.path.push(params_1.translateToPathParameter.call(this, param));
        }
        else if ((0, guards_2.isHeaderParam)(param)) {
            params.headers.push(params_1.translateToHeaderParam.call(this, param));
        }
        else if ((0, guards_2.isBodyParam)(param)) {
            bodyParameter = params_1.translateToBodyParameter.call(this, param, consumes);
        }
        else if ((0, guards_2.isFormDataParam)(param)) {
            formDataParameters.push(param);
        }
    }
    let body;
    if (!!bodyParameter) {
        body = bodyParameter;
    }
    else if (!!formDataParameters.length) {
        body = params_1.translateFromFormDataParameters.call(this, formDataParameters, consumes);
    }
    return {
        ...params,
        ...pickBy({
            body,
        }, guards_1.isNonNullable),
    };
};
exports.translateToRequest = translateToRequest;
//# sourceMappingURL=request.js.map